import React, { FunctionComponent } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { ApolloProvider } from '@apollo/react-hooks';
import { Auth } from '@justgiving/auth';
import { ExperimentContext } from '@justgiving/experiments';
import ApolloClient from 'apollo-client';

import App from '../../App';
import config from '../../client/config';
import { AuthContext } from '../../context/AuthContext';
import { FlagsProvider, AppFlags } from '../../context/FlagContext';
import {
  PageMetaContext,
  PageMetaContextProvider,
} from '../../context/PageMetaContext';

type AppWithProvidersProps = {
  helmetProviderContext?: {};
  pageMetaContextProviderValue: PageMetaContext | null;
  apolloProviderClient: ApolloClient<any>;
  i18n: any;
  auth: Auth;
};

const AppWithProviders: FunctionComponent<AppWithProvidersProps> = ({
  helmetProviderContext,
  pageMetaContextProviderValue,
  apolloProviderClient,
  i18n,
  auth,
}) => {
  return (
    <AuthContext.Provider value={auth}>
      <FlagsProvider value={(config.flags as unknown) as AppFlags}>
        <HelmetProvider context={helmetProviderContext}>
          <PageMetaContextProvider value={pageMetaContextProviderValue}>
            <ApolloProvider client={apolloProviderClient}>
              <ExperimentContext.Provider
                value={{
                  abServiceUrl: config.abApiUrl,
                  analyticsCookieName: config.analyticsCookieName,
                }}
              >
                <App i18n={i18n} />
              </ExperimentContext.Provider>
            </ApolloProvider>
          </PageMetaContextProvider>
        </HelmetProvider>
      </FlagsProvider>
    </AuthContext.Provider>
  );
};

export default AppWithProviders;
